import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { motion } from "framer-motion";
import { ContactHero } from "@/components/contact/ContactHero";
import { WhatYoullGet } from "@/components/contact/WhatYoullGet";
import ContactForm from "@/components/contact/ContactForm";
import { WhatHappensNext } from "@/components/contact/WhatHappensNext";
import { WhyChooseUs } from "@/components/contact/WhyChooseUs";
import { ContactCTA } from "@/components/contact/ContactCTA";

const Contact = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <ContactHero />
      
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16">
          {/* Left: What You'll Get + What Happens Next */}
          <div className="space-y-16">
            <WhatYoullGet />
            <WhatHappensNext />
          </div>
          
          {/* Right: Form */}
          <div>
            <ContactForm />
          </div>
        </div>
      </section>
      
      <WhyChooseUs />
      <ContactCTA />
      <Footer />
    </div>
  );
};

export default Contact;
